import React from 'react';
import './Differentiation.css';

function Differentiation() {
  return (
    <section className="differentiation section">
      <div className="container">
        <h2 className="section-title">Why This Is Different</h2>
        <div className="diff-grid">
          <div className="diff-card">
            <div className="diff-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <h3>Not another Excel course</h3>
            <p>You don't memorize formulas</p>
          </div>
          <div className="diff-card">
            <div className="diff-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                <path d="M2 17l10 5 10-5"></path>
                <path d="M2 12l10 5 10-5"></path>
              </svg>
            </div>
            <h3>Not just another AI tool</h3>
            <p>Mica actually executes tasks</p>
          </div>
          <div className="diff-card">
            <div className="diff-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
            </div>
            <h3>Not theory</h3>
            <p>Real workflows. Real files.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Differentiation;
